<template>
  <div class="new-customer">
    <div class="columns is-multiline">
      <div class="column is-12">
        <BField
          label="Nombre de cliente"
          label-for="privateName"
        >
          <BInput
            id="privateName"
            v-model="privateName"
            placeholder="Rafaeli Camposorio Ruízo"
            icon="account"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('name', $event)"
          />
        </BField>
      </div>

      <div class="column is-12">
        <BField
          label="Email"
          label-for="privateEmail"
        >
          <BInput
            id="privateEmail"
            v-model="privateEmail"
            placeholder="correo@mail.com"
            icon="email"
            type="email"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('email', $event)"
          />
        </BField>
      </div>

      <div class="column is-12">
        <BField
          label="RFC"
          label-for="privateRfc"
        >
          <BInput
            id="privateRfc"
            v-model="privateRfc"
            placeholder="PAL7202161U0"
            icon="fingerprint"
            :pattern="rfcPattern"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('rfc', $event)"
          />
        </BField>
      </div>
      <div class="column is-12">
        <BField
          label="Razón social"
          label-for="privateCompanyName"
        >
          <BInput
            id="privateCompanyName"
            v-model="privateCompanyName"
            placeholder="Machete SA de CV"
            icon="domain"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('companyName', $event)"
          />
        </BField>
      </div>

      <div class="column is-12">
        <AppSelectSearch
          id="privateTaxRegime"
          name="privateTaxRegime"
          label="Régimen fiscal"
          icon="domain"
          :options="taxRegimeCatalog"
          :value="taxRegimeSelected()"
          required
          @input="onInput('taxRegime', $event.target.value)"
          @change="onInput('taxRegime', $event.target.value)"
        />
      </div>

      <div class="column is-12">
        <BField
          label="Código postal"
          label-for="privateZipCode"
        >
          <BInput
            id="privateZipCode"
            v-model="privateZipCode"
            placeholder="00000"
            icon="account-card-details"
            :pattern="zipCodePattern"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('zipCode', $event)"
          />
        </BField>
      </div>

      <div class="column is-12">
        <BField
          label="Télefono celular"
          label-for="privateCellphoneNumber"
        >
          <BInput
            id="privateCellphoneNumber"
            v-model="privateCellphoneNumber"
            placeholder="5555555555"
            icon="domain"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('cellphoneNumber', $event)"
          />
        </BField>
      </div>

      <div class="column is-12">
        <BField
          label="Días de crédito"
          label-for="privateCreditDays"
        >
          <BInput
            id="privateCreditDays"
            v-model="privateCreditDays"
            placeholder="30"
            icon="bank"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('creditDays', $event)"
          />
        </BField>
      </div>

      <div class="column is-12">
        <BField
          label="Limite de crédito"
          label-for="privateCreditLimit"
        >
          <BInput
            id="privateCreditLimit"
            v-model="privateCreditLimit"
            placeholder="30"
            icon="bank"
            :disabled="loading"
            :loading="loading"
            required
            @input="onInput('creditLimit', $event)"
          />
        </BField>
        <p class="help">
          {{ privateCreditLimit | toCurrency('MXN') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import helpers from '../../../lib/helpers';

export default {
  name: 'NewCustomer',
  components: {
    AppSelectSearch: () => import(/* webpackChunkName: "app-select-search" */ '@/components/AppSelectSearch'),
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      privateName: this.$store.state.customers.name,
      privateCreditDays: this.$store.state.customers.creditDays,
      privateEmail: this.$store.state.customers.email,
      privateRfc: this.$store.state.customers.rfc,
      privateCompanyName: this.$store.state.customers.companyName,
      privateCreditLimit: this.$store.state.customers.creditLimit,
      privateCellphoneNumber: this.$store.state.customers.cellphoneNumber,
      privateZipCode: this.$store.state.customers.zipCode,
      zipCodePattern: '^[0-9]{5}(?:-[0-9]{4})?$',
      rfcPattern: '^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$',
    };
  },
  computed: {
    ...mapState({
      privateTaxRegime: ({ customers }) => customers.taxRegime,
      taxRegimeCatalog: ({ ui, customers }) => {
        const { taxRegime } = ui.catalogSat;
        const { rfc } = customers;

        return helpers.arrayToOptionsFilterByRFC(taxRegime, rfc);
      },
    }),
  },
  beforeDestroy() {
    this.$store.commit('customers/setValues', {
      name: '',
      creditDays: 0,
      email: '',
      rfc: '',
      companyName: '',
      creditLimit: 0,
      cellphoneNumber: '',
      zipCode: '',
      taxRegime: '',
    });
  },
  methods: {
    taxRegimeSelected() {
      const itemSelected = this.taxRegimeCatalog.find(
        regime => regime.value === this.privateTaxRegime,
      );

      if (!itemSelected) {
        this.onInput('taxRegime', '');
      }

      return itemSelected;
    },
    onInput(name, event) {
      this.$store.commit('customers/setValue', { accessor: name, value: event });
    },
    async save() {
      try {
        await this.$store.dispatch('customers/create');
        this.$success({ message: 'Cliente creado exitosamente' });
        this.$router.push({ name: 'Customers' });
      } catch (error) {
        this.$danger({ message: error.message });
      }
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 769px) {
  .new-customer {
    max-width: 100%;
  }
}
</style>
